<template>
  <LoadingWithText v-if="isLoading" />
  <div v-else class="grid grid-cols-12 gap-6">
    <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">
      <div class="col-span-12 mt-8">
        <div class="intro-y flex items-center  h-10">
          <PageHeader
            class="text-lg font-medium mr-auto"
            :title="$t('dashboard.titleGeneralReports')"
          />
          <!-- <button
            type="button"
            @click="fetchData"
            class="ml-auto flex text-theme-1 dark:text-theme-10"
          >
            <RefreshCcwIcon class="w-4 h-4 mr-3" /> Reload Data
          </button> -->
        </div>
        <DashboardGeneralReports :report="dashboard" />
      </div>
      <div class="col-span-12 lg:col-span-9 mt-8">
        <DashboardLendingByMonth :report="dashboard" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-3 mt-8">
        <DashboardLendingByAge :report="dashboard" />
      </div>
      <div class="col-span-12 lg:col-span-9 mt-8">
        <DashboardLendingByDay :report="dashboard" />
      </div>
      <!-- <div class="col-span-12 sm:col-span-6 lg:col-span-3 mt-8">
        <DashboardLendingByStatus :report="dashboard" />
      </div> -->

      <div class="col-span-12 sm:col-span-6 lg:col-span-3 mt-8">
        <DashboardLendingByGender :report="dashboard" />
      </div>
      <!-- <div class="col-span-12 mt-8">
        <DashboardSecondReports :report="dashboard" />
      </div> -->
      <!-- <div class="col-span-12 sm:col-span-6 lg:col-span-3 mt-8">
        <DashboardLendingByEducation :report="dashboard" />
      </div> -->
      <!-- <div class="col-span-12 lg:col-span-6 mt-8">
        <DashboardIncomeOfInterestAndFeeByMonth :report="dashboard" />
      </div>
      <div class="col-span-12 lg:col-span-6 mt-8">
        <DashboardIncomeOfInterestAndFeeByDay :report="dashboard" />
      </div> -->
    </div>
    <div class="col-span-12 xxl:col-span-3 xxl:border-l border-theme-5 -mb-10 pb-10">
      <div class="xxl:pl-6 grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3 xxl:mt-8">
          <DashboardTransactions :report="dashboard" />
        </div>
        <div class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3">
          <DashboardTransactionsBetweenAccounts :report="dashboard" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DASHBOARD_REQUEST } from '@/store/actions/report';
import PageHeader from '@/components/ui/PageHeader';
import DashboardGeneralReports from '@/components/dashboard/DashboardGeneralReports';
// import DashboardSecondReports from '@/components/dashboard/DashboardSecondReports';
import DashboardLendingByMonth from '@/components/dashboard/DashboardLendingByMonth';
// import DashboardLendingByStatus from '@/components/dashboard/DashboardLendingByStatus';
import DashboardLendingByAge from '@/components/dashboard/DashboardLendingByAge';
import DashboardLendingByDay from '@/components/dashboard/DashboardLendingByDay';
import DashboardLendingByGender from '@/components/dashboard/DashboardLendingByGender';
// import DashboardLendingByEducation from '@/components/dashboard/DashboardLendingByEducation';
import DashboardTransactions from '@/components/dashboard/DashboardTransactions';
import DashboardTransactionsBetweenAccounts from '@/components/dashboard/DashboardTransactionsBetweenAccounts';
// import DashboardIncomeOfInterestAndFeeByMonth from '@/components/dashboard/DashboardIncomeOfInterestAndFeeByMonth';
// import DashboardIncomeOfInterestAndFeeByDay from '@/components/dashboard/DashboardIncomeOfInterestAndFeeByDay';

export default {
  name: 'Dashboard',

  components: {
    PageHeader,
    DashboardGeneralReports,
    // DashboardSecondReports,
    DashboardLendingByMonth,
    // DashboardLendingByStatus,
    DashboardLendingByAge,
    DashboardLendingByDay,
    DashboardLendingByGender,
    // DashboardLendingByEducation,
    DashboardTransactions,
    DashboardTransactionsBetweenAccounts,
    // DashboardIncomeOfInterestAndFeeByMonth,
    // DashboardIncomeOfInterestAndFeeByDay,
  },

  computed: {
    ...mapGetters(['dashboard', 'dashboardStatus']),
    isLoading() {
      return this.dashboardStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      await this.$store.dispatch(DASHBOARD_REQUEST);
    },
  },
};
</script>
